import React, { useEffect, useState } from 'react'
// import './dashboard.css'
import './adminpanel.css'
import { useAuthContext } from '../../Hooks/useAuthContext'
import axios from 'axios'
import { FaAlignLeft, FaSignOutAlt, FaTimes, FaUserAlt } from 'react-icons/fa'
import { toast } from 'wc-toast'
import AdminConfirm from './AdminConfirm'
import { Link, useNavigate } from 'react-router-dom'
import AdminSidebar from './AdminSideBar'
import Loader from '../../Component/Loader/Loader'

function LoanRequest() {
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [data, setData]                       = useState([])
  const [btnState, setBtnState]               = useState('Change Loan Status')
  const [edit, setEdit]                       = useState(false)
  const [depositId, setDepositId]             = useState(null)
  const [confirm, setConfirm]                 = useState(false)
  const [updateData, setUpdateData]           = useState(null)
  const [image, setImage]                     = useState(false)
  const [loading, setLoading]                 = useState(true)
  const [formData, setFormData]               = useState({ status: '', currency: '', img: null })

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)     { /* ok */ }
      else if (r.data.user) navigate('/admin-panel')
      else                  navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  /* Fetch loans */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/loans`, {
          headers: { Authorization: `Bearer ${user.token}` },
        })
        setData(r.data)
      } catch (e) { console.log(e) }
      finally    { setLoading(false) }
    }
    fetchData()
  }, [user.token, updateData])

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  const handleChange    = (e) => setFormData(p => ({ ...p, [e.target.id]: e.target.value }))
  const handleEditClick = (d)  => { setEdit(true); setDepositId(d._id); setFormData(p => ({ ...p, currency: d.currency })) }
  const handleDelete    = (id) => { setDepositId(id); setConfirm(true) }
  const onCancel        = ()   => setConfirm(false)

  const onConfirm = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/delete-loan/${depositId}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      toast.success('Deleted Successfully')
      setConfirm(false)
      setUpdateData(depositId)
    } catch (e) { console.log(e) }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setBtnState('Processing...')
    try {
      const r = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/admin/loan/${depositId}`,
        { action: formData.status, currency: formData.currency },
        { headers: { Authorization: `Bearer ${user.token}` } }
      )
      toast.success('Status Updated Successfully')
      setUpdateData(r.data)
      setEdit(false)
    } catch (e) {
      toast.error(e.response.data)
    } finally {
      setBtnState('Change Loan Status')
    }
  }

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>{process.env.REACT_APP_APP_NAME}<span className="admin-badge">Admin</span></p>
          </Link>
          <FaAlignLeft size={18} onClick={() => { setShouldMenuSlide(true); setSideMenu(!sidemenu) }} />
        </div>
        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(p => !p)}><FaUserAlt size={14} /></div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}><FaSignOutAlt size={13} /> Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar ─────────────────────────────────────── */}
      {sidemenu && <AdminSidebar shouldMenuSlide={shouldMenuSlide} onClose={() => setSideMenu(false)} />}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        <div className="loan-container">
          <div className="table-head">
            <div>
              <div className="db-breadcrumb">Admin &nbsp;/&nbsp; <span>Loans</span></div>
              <h2>Loan Requests</h2>
            </div>
          </div>

          {loading ? <Loader /> : (
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="loan-table">
                <table className="equal-table">
                  <thead>
                    <tr>
                      <th>User Email</th>
                      <th>Loan Product</th>
                      <th>Requested</th>
                      <th>Total Payable</th>
                      <th>Amount Paid</th>
                      <th>Status</th>
                      <th>ID Proof</th>
                      <th>Note</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? data.map(item => (
                      <tr key={item._id}>
                        <td>{item.userEmail}</td>
                        <td>{item.loanProduct}</td>
                        <td>{item.amount} {item.currency}</td>
                        <td>{item.totalpayableAmount}</td>
                        <td>{item.amountPaid}</td>
                        <td>
                          <span className={`db-badge db-badge--${item.status === 'Approved' ? 'success' : item.status === 'Rejected' ? 'danger' : 'warning'}`}>
                            {item.status}
                          </span>
                        </td>
                        <td>
                          <button className="db-btn db-btn--ghost db-btn--sm" onClick={() => {
                            setFormData(p => ({ ...p, img: item.img }))
                            setImage(true)
                          }}>View</button>
                        </td>
                        <td>{item.note}</td>
                        <td>
                          <div className="action-tb">
                            <button className="db-btn db-btn--ghost db-btn--sm" onClick={() => handleEditClick(item)}>Edit</button>
                            <button className="db-btn db-btn--danger db-btn--sm" onClick={() => handleDelete(item._id)}>Delete</button>
                          </div>
                        </td>
                      </tr>
                    )) : (
                      <tr><td colSpan="9" className="no-loan-message">No Loan Requests</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Edit overlay ─────────────────────────────────── */}
      {edit && (
        <div className="deposits-form">
          <button className="wd-close" onClick={() => setEdit(false)} aria-label="Close"><FaTimes size={14} /></button>
          <div className="send-money-container" style={{ width: '100%', maxWidth: '480px' }}>
            <form className="send-money-form" onSubmit={handleSubmit}>
              <h2>Edit Loan Status</h2>
              <div className="send-money-form-group">
                <label htmlFor="status">Status <span>*</span></label>
                <select id="status" value={formData.status} onChange={handleChange} required>
                  <option value="" disabled>Select One</option>
                  <option value="Approve">Approve</option>
                  <option value="Reject">Reject</option>
                </select>
              </div>
              <div style={{ padding: '0 2rem' }}>
                <button type="submit" className="send-money-send-btn" disabled={btnState === 'Processing...'}>
                  {btnState === 'Processing...' ? 'Processing…' : 'Update Status →'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {confirm && <AdminConfirm message="Are you sure you want to delete?" onConfirm={onConfirm} onCancel={onCancel} />}

      {/* ── ID proof image viewer ────────────────────────── */}
      {image && formData.img && (
        <div className="dataImg">
          <button className="dataImg__close" onClick={() => setImage(false)} aria-label="Close">
            <FaTimes size={14} />
          </button>
          <img src={`${process.env.REACT_APP_IMG_BACKEND_URL}images/${formData.img}`} alt="Identity proof" />
        </div>
      )}
    </div>
  )
}

export default LoanRequest